<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!-- 		 	 -->
<!-- LOCK TO TOP -->
<!-- 			 -->
<div class="lock-to-top-off" style="background-color: #ffffff">
	<!-- 				 -->
	<!-- School Selector -->
	<!-- 				 -->
	<div class="selector-body">
		<div class="selector-item">
			<div>
				<label>School</label>
			</div>

			<div style="margin-left: 10px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<!-- <select class="form-control" name="SchoolSelector" style="font-size:smaller;"
					[(ngModel)]="SelectedSchool"
					(ngModelChange)="onSchoolChange($event)">
					<option *ngFor="let r of lstSchool" [ngValue]="r">{{r.SchoolNumber}} - {{r.SchoolName}}</option>
				</select> -->

				<caass-schoolselector [ShowAll]="SchoolSelectShowAll" [ShowAllID]="SchoolSelectShowAllID" [ShowAllText]="SchoolSelectShowAllText">
				</caass-schoolselector>
			</div>

			<div class="radio-body">
				<div>
					<p-radioButton name="groupSelectorMode" value="0" [(ngModel)]="IsShippedWithinLastMonthMode" (onClick)="onRadioMode1()"></p-radioButton>
				</div>
				<div style="margin-left: 5px">
					<label>All Time</label>
				</div>

				<div style="margin-left: 15px">
					<p-radioButton name="groupSelectorMode" value="1" [(ngModel)]="IsShippedWithinLastMonthMode" (onClick)="onRadioMode2()"></p-radioButton>
				</div>
				<div style="margin-left: 5px">
					<label>Within Last Month</label>
				</div>
			</div>
		</div>
	</div>

	<!-- 		 -->
	<!-- Buttons -->
	<!-- 		 -->
	<div class="button-body">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onReceive()" [disabled]="isBusy == true">Receive Shipment</button>
		<img class="info-img" (click)="onToggleInfo()" src="assets/images/info-24.png" />
	</div>

	<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfo == true ? 'block' : 'none'">
		<label>&#9900; Total shipment items: {{ lstMTACardShipment.length }}</label
		><br />
		<label>&#9900; Use ctl to add a column to the sort selection</label><br />
	</div>
</div>

<!-- 					  -->
<!-- Display PrintQ Items -->
<!-- 					  -->
<div class="table-main-body">
	<!-- Note: resizableColumns breaks the multiline ability -->

	<p-table
		#mydt
		[value]="lstMTACardShipment"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedMTACardShipment"
		dataKey="MTACardShipmentID"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50, 100]"
	>
		<ng-template pTemplate="header">
			<!-- 				-->
			<!-- Filter Section -->
			<!-- 				-->
			<tr>
				<th>
					<div class="filter-column-group">
						<!-- 				   -->
						<!-- Display When Busy -->
						<!-- 				   -->
						<div [style.display]="isBusy == true ? 'block' : 'none'" style="width: 20px">
							<img class="busy-img" src="assets/images/loading.gif" />
						</div>
						<div [style.display]="isBusy == false ? 'block' : 'none'" style="width: 20px"></div>
						<!-- Show/Hide Buttons -->
						<div class="p-d-flex" style="margin-left: 15px" [style.display]="isShowShipmentTime == false ? 'block' : 'none'">
							<button
								pButton
								style="width: 100px"
								label="Ship Time"
								class="p-button-outlined"
								icon="pi pi-plus-circle"
								(click)="ontoggleShipmentTime()"
							></button>
						</div>
						<div class="p-d-flex" style="margin-left: 15px" [style.display]="isShowShipmentTime == true ? 'block' : 'none'">
							<button
								pButton
								style="width: 100px"
								label="Ship Time"
								class="p-button-outlined"
								icon="pi pi-minus-circle"
								(click)="ontoggleShipmentTime()"
							></button>
						</div>

						<div class="p-d-flex" style="margin-left: 5px" [style.display]="isShowReceivedTime == false ? 'block' : 'none'">
							<button
								pButton
								style="width: 100px"
								label="Receive Time"
								class="p-button-outlined"
								icon="pi pi-plus-circle"
								(click)="ontoggleReceivedTime()"
							></button>
						</div>
						<div class="p-d-flex" style="margin-left: 5px" [style.display]="isShowReceivedTime == true ? 'block' : 'none'">
							<button
								pButton
								style="width: 100px"
								label="Receive Time"
								class="p-button-outlined"
								icon="pi pi-minus-circle"
								(click)="ontoggleReceivedTime()"
							></button>
						</div>
					</div>
				</th>

				<th style="text-align: right">
					<div class="p-d-flex">
						<button pButton label="Clear" class="p-button-outlined" icon="pi pi-filter-slash" (click)="onClearFilters()"></button>
					</div>
				</th>

				<th>
					<p-columnFilter field="MTACardShipmentStatusDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterMTACardShipmentStatus
								[ngModel]="value"
								[options]="lstMTACardShipmentStatuses"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th></th>
				<!-- Placeholder -->
			</tr>

			<!-- 			  -->
			<!-- Sort Section -->
			<!-- 			  -->
			<tr>
				<th pSortableColumn="ShipmentDT">Ship Date<p-sortIcon field="ShipmentDT"></p-sortIcon></th>
				<th pSortableColumn="ReceivedDT">Receive Date<p-sortIcon field="ReceivedDT"></p-sortIcon></th>
				<th pSortableColumn="MTACardShipmentStatusDesc">Status<p-sortIcon field="MTACardShipmentStatusDesc"></p-sortIcon></th>
				<th pSortableColumn="qty">Quantity<p-sortIcon field="qty"></p-sortIcon></th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-rMTACardShipmentItem>
			<tr [pSelectableRow]="rMTACardShipmentItem">
				<td>
					<div [style.display]="isShowShipmentTime == true ? 'block' : 'none'">
						{{ rMTACardShipmentItem.ShipmentDT | date : "EEEE, MMMM d, y  h:mm a" }}
					</div>
					<div [style.display]="isShowShipmentTime == false ? 'block' : 'none'">
						{{ rMTACardShipmentItem.ShipmentDT | date : "fullDate" }}
					</div>
				</td>

				<td>
					<div [style.display]="rMTACardShipmentItem.ReceivedDT != '0001-01-01T00:00:00' && isShowReceivedTime == true ? 'block' : 'none'">
						{{ rMTACardShipmentItem.ReceivedDT | date : "EEEE, MMMM d, y  h:mm a" }}
					</div>
					<div [style.display]="rMTACardShipmentItem.ReceivedDT != '0001-01-01T00:00:00' && isShowReceivedTime == false ? 'block' : 'none'">
						{{ rMTACardShipmentItem.ReceivedDT | date : "fullDate" }}
					</div>
					<div [style.display]="rMTACardShipmentItem.ReceivedDT == '0001-01-01T00:00:00' ? 'block' : 'none'"></div>
				</td>

				<td>
					<div
						[ngClass]="{
							'table-data-status-1': rMTACardShipmentItem.MTACardShipmentStatusID == 1,
							'table-data-status-2': rMTACardShipmentItem.MTACardShipmentStatusID == 2,
							'table-data-status-3': rMTACardShipmentItem.MTACardShipmentStatusID == 3,
							'table-data-status-4': rMTACardShipmentItem.MTACardShipmentStatusID == 4,
							'table-data-status-5': rMTACardShipmentItem.MTACardShipmentStatusID == 5,
							'table-data-status-6': rMTACardShipmentItem.MTACardShipmentStatusID == 6
						}"
					>
						{{ rMTACardShipmentItem.MTACardShipmentStatusDesc }}
					</div>
				</td>

				<td>
					<div>
						{{ rMTACardShipmentItem.qty }}
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!-- 						     -->
<!-- Display When Shipment Items -->
<!-- 					         -->
<div style="padding: 20px" [style.display]="lstMTACardShipment.length < 1 && isBusy == false ? 'block' : 'none'">
	<label>No Shipments...</label>
</div>
